import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const VISITOR_KEY = 'cgm_visitor_id';

const uid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);

const visitorId = () => {
  try {
    let v = localStorage.getItem(VISITOR_KEY);
    if (!v) { v = uid(); localStorage.setItem(VISITOR_KEY, v); }
    return v;
  } catch { return null; }
};

const externalReferrer = () => {
  try {
    const host = document.referrer ? new URL(document.referrer).host : null;
    return host && host !== window.location.host ? host.slice(0, 100) : null;
  } catch { return null; }
};

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const buildMeta = (language) => ({
  visitor_id: visitorId(),
  page_path: window.location.pathname.slice(0, 300),
  referrer_host: externalReferrer(),
  language,
});

export const mediaUrl = (path) => (path && path.startsWith('/') ? `${BACKEND_URL}${path}` : path);

export async function searchSite({ q, section = 'all', source = 'results_page', language, log = true }) {
  const { data } = await axios.post(
    `${BACKEND_URL}/api/search`,
    { q, section, source, lang: language, log, meta: buildMeta(language) },
    { headers: authHeaders(), timeout: 15000 }
  );
  return data;
}

export async function suggestSite(q, language) {
  const { data } = await axios.get(`${BACKEND_URL}/api/search/suggest`, { params: { q, lang: language }, timeout: 8000 });
  return data;
}

export async function popularSearches(language) {
  const { data } = await axios.get(`${BACKEND_URL}/api/search/popular`, { params: { lang: language }, timeout: 8000 });
  return data.items || [];
}

export function logSuggestionClick({ q, item, position, resultsCount, language }) {
  axios.post(
    `${BACKEND_URL}/api/search/log`,
    {
      q, source: 'header_suggestion', results_count: resultsCount,
      clicked: { section: item.section, id: item.id, title: item.title_ar || item.title_en, position },
      meta: buildMeta(language),
    },
    { headers: authHeaders() }
  ).catch(() => {});
}

export function logResultClick(searchId, clicked) {
  if (!searchId) return;
  axios.post(`${BACKEND_URL}/api/search/click`, { search_id: searchId, clicked }).catch(() => {});
}

export const SECTION_TABS = ['numbers', 'plates', 'cars', 'real_estate', 'products', 'stores', 'services', 'activities', 'buy_requests', 'pages'];
